import React, { useEffect } from 'react';
import './float.scss';
import { floatData } from './floatData';

function Float({ index, floatRef }) {
  const { head, copy, quote, name, copyType } = floatData[index];
  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.5) {
            entry.target.style.opacity = '1';
          }
        });
      },
      { threshold: [0, 0.5, 1] }
    );
    observer.observe(floatRef.current);
  }, [floatRef]);
  return (
    <div className={head ? 'float float--aside' : 'float float--quote'}>
      {head ? (
        <div className="float__text" ref={floatRef}>
          <h6>{head}</h6>
          <p>
            {copy.map((text, i) => {
              return copyType[i] === 'text' ? (
                <span key={`float-${i}`}>{text}</span>
              ) : (
                <sup key={`float-${i}`}>{text}</sup>
              );
            })}
          </p>
        </div>
      ) : (
        <blockquote className="float__text" ref={floatRef}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="22"
            viewBox="0 0 28 22"
            fill="none"
            className="float--quote__mark"
          >
            <path
              d="M13.2766 0L13.9574 2.32521C8.76596 3.84553 5.95745 6.61789 5.19149 10.6423H5.78723C8.85106 10.6423 10.8936 13.1463 10.8936 16.2764C10.8936 19.2276 9.02127 22 5.3617 22C2.21277 22 0 19.7642 0 15.2927C0 7.15447 6.21277 1.52033 13.2766 0ZM19.9149 10.6423C22.9787 10.6423 25.0213 13.1463 25.0213 16.2764C25.0213 19.2276 23.1489 22 19.4894 22C16.2553 22 14.1277 19.7642 14.1277 15.2927C14.1277 7.15447 20.2553 1.52033 27.4043 0L28 2.32521C22.8085 3.84553 20.0851 6.61789 19.3191 10.6423H19.9149Z"
              fill="#EB1700"
            />
          </svg>
          {quote}
          <footer>{name}</footer>
        </blockquote>
      )}
    </div>
  );
}

export default Float;
